<template>
  <div>
    <v-row>
      <page-title value="クラス日誌"></page-title>
      <v-spacer></v-spacer>
      <!-- 印刷 -->
      <v-btn color="black" class="mx-2" variant="outlined">
        <v-icon start>mdi-printer</v-icon>
        印刷
      </v-btn>
      <!-- 下書き保存 -->
      <v-btn color="primary" class="mx-2" variant="outlined">下書き保存</v-btn>
      <!-- 申請 -->
      <v-btn color="primary" class="ml-2" variant="flat">申請</v-btn>
    </v-row>
    <v-row>
      <date-pager class="pt-4"></date-pager>
    </v-row>

    <v-container fluid class="pt-10">
      <v-row>
        <v-col cols="6">
          <div class="pb-2">ねらい</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
        <v-col cols="6">
          <div class="pb-2">活動内容</div>
          <v-text-field variant="outlined" label="午前"></v-text-field>
          <v-text-field variant="outlined" label="午後"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <div class="pb-2">評価と反省</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
        <v-col cols="6">
          <div class="pb-2">保護者支援</div>
          <v-textarea variant="outlined"></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import DatePager from "@/components/atoms/DatePager.vue";

export default defineComponent({
  name: "ClassReportDetail",

  components: {
    PageTitle,
    DatePager,
  },
});
</script>
